// Schematic line colours of the active organization (doc 07 §2.2): the library defaults unless
// the organization chose its own in Administration → Organization settings.
import { LINE_STYLES, type LineFluid } from '@twinlink/shared';

let overrides: Record<string, string> = {};

export function setLineColors(colors: Record<string, string> | undefined): void {
  overrides = colors ?? {};
}

export function lineColor(fluid: LineFluid): string {
  return overrides[fluid] ?? LINE_STYLES[fluid].color;
}

export function lineStyle(fluid: LineFluid): (typeof LINE_STYLES)[LineFluid] {
  return { ...LINE_STYLES[fluid], color: lineColor(fluid) };
}
